import { useState } from 'react';
import { login_request_url, login_facebook_request_url, login_google_request_url } from '../Utilities/apiUrl';
import usePostMessage from './UsePostMessage';
import consts from '../Utilities/appConsts.json';
import useIframeParams from './useIframeParam';
import useLoader from './useLoader';
import { JwtPayload, jwtDecode } from "jwt-decode";

interface LoginPageHook {
  mail: string;
  setMail: React.Dispatch<React.SetStateAction<string>>;
  password: string;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  setIsShowHelperTextEmail: React.Dispatch<React.SetStateAction<boolean>>;
  setIsShowHelperTextPassword: React.Dispatch<React.SetStateAction<boolean>>;
  isShowHelperTextEmail: boolean;
  isShowHelperTextPassword: boolean;
  handleResponse: (response: any) => Promise<void>;
  handleFacebookResponse: (response: any) => Promise<void>;
  handleGoogleResponse: (response: any) => Promise<void>;
  setIsAddActiveModal: React.Dispatch<React.SetStateAction<boolean>>;
  isAddActiveModal: boolean;
  titleModal: string;
  contentModal: string;
  textTrueModal: string;
  textFalseModal: string;
  setCheckRemember: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  checkRemember: boolean;
  LoaderComponent: React.FC<any>;
}

interface ModalData {
  title: string;
  content: string;
  textTrue: string;
  textFalse?: string;
}


const useLoginPage = (): LoginPageHook => {
  const [mail, setMail] = useState('');
  const [password, setPassword] = useState('');
  const [isShowHelperTextEmail, setIsShowHelperTextEmail] = useState(false);
  const [isShowHelperTextPassword, setIsShowHelperTextPassword] = useState(false);
  const [isAddActiveModal, setIsAddActiveModal] = useState(false);
  const [titleModal, setTitleModal] = useState('');
  const [contentModal, setContentModal] = useState('');
  const [textTrueModal, setTextTrueModal] = useState('');
  const [textFalseModal, setTextFalseModal] = useState('');
  const [checkRemember, setCheckRemember] = useState(true);
  const { loading, showLoading, hideLoading, LoaderComponent } = useLoader();
  // You can also move the following context and functions into the hook if needed.
  const postMessage = usePostMessage();
  const channel = useIframeParams('channel') || "";
  const temptoken = useIframeParams('temptoken') || "";

  const handleResponse = async (response: any): Promise<void> => {
    try {
      showLoading();
      const data = await fetch(`${login_request_url}&password=${encodeURIComponent(password)}&email=${mail}&channel=${channel}&temptoken=${temptoken}&remember=${checkRemember}`);
      const data_json = await data.json();

      if (!data_json.isValid) {
        if (data_json.errorCode == 528) {
          showModal({
            title: "לא חבל?",
            content: "שלחנו למייל שלך קישור להפעלת החשבון, ועוד לא הפעלת אותו",
            textTrue: "אופס, אלך להפעיל"
          });
        } else if (data_json.errorCode == 546) {
          showModal({
            title: "אופס",
            content: "החשבון הזה נסגר לבקשתך. כדי להתחבר צריך להקליד כתובת מייל אחרת",
            textTrue: "הבנתי"
          });
        }
        else {
          setIsShowHelperTextEmail(true);
          setIsShowHelperTextPassword(true);
        }

      }
      else {
        postMessage(data_json.payLoad);
      }
    } catch (error) {
      setIsShowHelperTextEmail(true);
    }
    finally {
      hideLoading();
    }
  };

  const handleFacebookResponse = async (response: any): Promise<void> => {
    // Handle the Facebook login response
    showLoading();
    const data = await fetch(`${login_facebook_request_url}&firstname=${response?.name}&lastname=${response?.name}&email=${response?.email}&channel=${channel}&temptoken=${temptoken}&remember=${checkRemember}`);
    const data_json = await data.json();
    if (!data_json.isValid) {
      if (data_json.errorCode == 546) {
        showModal({
          title: "אופס",
          content: "החשבון הזה נסגר לבקשתך. כדי להתחבר צריך להקליד כתובת מייל אחרת",
          textTrue: "הבנתי"
        });
      }
    }
    postMessage(data_json.payLoad);
    hideLoading();
  };

  const handleGoogleResponse = async (response: any): Promise<void> => {
    showLoading();
    const decode = jwtDecode<JwtPayload>(response.credential);
    const dataGoogle = JSON.parse(JSON.stringify(decode));
    const data = await fetch(`${login_google_request_url}&firstname=${dataGoogle?.given_name}&lastname=${dataGoogle.family_name}&email=${dataGoogle.email}&channel=${channel}&temptoken=${temptoken}&remember=${checkRemember}`);
    const data_json = await data.json();
    if (!data_json.isValid) {
      if (data_json.errorCode == 546) {
        showModal({
          title: "אופס",
          content: "החשבון הזה נסגר לבקשתך. כדי להתחבר צריך להקליד כתובת מייל אחרת",
          textTrue: "הבנתי"
        });
      }
    }
    postMessage(data_json.payLoad);
    hideLoading();
  };


  function showModal({
    title,
    content,
    textTrue,
    textFalse = "" }: ModalData): void {
    setIsAddActiveModal(true);
    setTitleModal(title);
    setContentModal(content);
    setTextTrueModal(textTrue);
    setTextFalseModal(textFalse);
  }

  return {
    mail,
    setMail,
    password,
    setPassword,
    setIsShowHelperTextEmail,
    setIsShowHelperTextPassword,
    isShowHelperTextEmail,
    isShowHelperTextPassword,
    handleResponse,
    handleFacebookResponse,
    handleGoogleResponse,
    isAddActiveModal,
    setIsAddActiveModal,
    titleModal,
    contentModal,
    textTrueModal,
    textFalseModal,
    setCheckRemember,
    loading,
    checkRemember,
    LoaderComponent
  } as LoginPageHook;
};

export default useLoginPage;
